import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../core/services/api.service';
import { IUserActivityDetail, IUserActivityListResponse } from '../models/user-activity.models';

@Injectable({
	providedIn: 'root',
})
export class UserActivityService extends ApiService {
	public list(body: Record<string, unknown> | object): Observable<IUserActivityListResponse> {
		return this.http.post<IUserActivityListResponse>(`${environment.apiUrl}/user-activities`, body, {
			headers: this.getHeaders(),
		});
	}

	public get(uuid: string, params?: Record<string, string>): Observable<IUserActivityDetail> {
		return this.http
			.get<{ data: IUserActivityDetail } | IUserActivityDetail>(`${environment.apiUrl}/user-activity/${uuid}`, {
				headers: this.getHeaders(),
				params,
			})
			.pipe(map((r: any) => (r && typeof r === 'object' && 'data' in r ? r.data : r)));
	}
}
